<template lang="html">

  <form id="formContacto" @submit.prevent="validateBeforeSubmit">

    <div class="contenedor-input">
      <input type="text" class="input-text"
      v-validate="'required'"
      name="nombre" :placeholder="$t('formulario.nombre_apellidos')+'*'"/>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('nombre') }}</span>
    </div>

    <div class="contenedor-input">
      <input type="text" class="input-text"
      v-validate="'required|email'"
      name="email" :placeholder="$t('formulario.email')+'*'"/>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
    </div>

    <div class="contenedor-input">
      <input type="text" class="input-text"
      v-validate="'length:9'"
      name="telefono" :placeholder="$t('formulario.telefono')"/>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('telefono') }}</span>
    </div>


    <div class="contenedor-input">
      <textarea :placeholder="$t('formulario.mensaje')+'*'"
      name="mensaje" v-validate="'required'"></textarea>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('mensaje') }}</span>
    </div>

    <button>{{$t('formulario.enviar')}}</button>

  </form>

</template>

<script lang="js">


  import Vue from 'vue';
  import VeeValidate from 'vee-validate';

  Vue.use(VeeValidate);

  import {mapGetters, mapActions} from 'vuex'

  export default  {
    name: 'formulario',
    props: [],
    mounted() {

    },
    data() {
      return {
        clicked : false
      }
    },
    methods: {
      ...mapActions(['sendContacto']),
      validateBeforeSubmit : function(){

        this.clicked = true;
        this.$validator.validateAll().then(canSend => {
          if(canSend){
            this.sendContacto($("#formContacto").serialize())
            .then(result =>{
              console.log(result);
            });
          }
        });
      },
    },
    computed: {

    }
  }
</script>

<style scoped lang="scss">
.contacto {

}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/contacto/formulario.vue